/*global google*/

import * as React from "react";
import * as PropTypes from "prop-types";
import { MapComponentProps } from "./map";
import { Location, locationPropType, mapLocation } from "./location";
import { Animation, getAnimation } from "./util";

interface MarkerProps extends MapComponentProps {
    position: Location;
    icon: string;
    animation?: Animation;
    zIndex?: number;
    onClick?: () => void;
    children?: never;
}

export class Marker extends React.PureComponent<MarkerProps>{

    static propTypes = {
        //TODO: MapComponentProps
        icon: PropTypes.string.isRequired,
        onClick: PropTypes.func,
        position: locationPropType.isRequired,
        animation: PropTypes.oneOf([Animation.BOUNCE, Animation.DROP, Animation.NONE])
    }

    static displayName = "GoogleMaps.Marker";

    private listener?: google.maps.MapsEventListener;
    private marker?: google.maps.Marker;

    private onClick = () => this.props.onClick && this.props.onClick();

    componentDidMount() {
        this.marker = new google.maps.Marker(this.getOptions());
        this.listener = google.maps.event.addListener(this.marker, 'click', this.onClick);
    }

    componentWillUnmount() {
        this.marker && this.marker.setMap(null);
        this.listener && this.listener.remove();
    }

    componentDidUpdate(prevProps: MarkerProps) {
        if (this.marker) {
            if (this.props.icon !== prevProps.icon) {
                this.marker.setIcon(this.props.icon);
            }
            if (this.props.position !== prevProps.position) {
                this.marker.setPosition(mapLocation(this.props.position));
            }
            if (this.props.zIndex && this.props.zIndex !== prevProps.zIndex) {
                this.marker.setZIndex(this.props.zIndex)
            }
        }
    }

    render(): null {
        return null;
    }

    getComponent() {
        return this.marker;
    }

    private getOptions(): google.maps.MarkerOptions {
        const {
            onClick,
            position,
            children,
            animation,
            icon,
            ...props
        } = this.props;

        return {
            position: mapLocation(position),
            animation: getAnimation(animation),
            optimized: false,
            icon: {
                scaledSize: new google.maps.Size(20, 20),
                url: icon
            },
            ...props
        }
    }
}
